import { VERIFICATION_STATUS } from '../constants/PlaidRequirement';

export const getPaymentMethodStatuses = (paymentMethods) => {
  return paymentMethods.reduce(
    (acc, pm) => {
      // Only bank accounts can need verification
      if (pm.accountType === 'bank_account' && pm.isBankAccountVerificationNeeded) {
        acc.hasPaymentMethodNeedingVerification = true;
      } else {
        acc.hasVerifiedPaymentMethod = true;
      }
      return acc;
    },
    { hasPaymentMethodNeedingVerification: false, hasVerifiedPaymentMethod: false },
  );
};

export const getVerifiedPaymentMethods = (paymentMethods) => {
  return (
    paymentMethods?.filter(
      (paymentMethod) =>
        paymentMethod.paymentMethodStatus === 'verified' ||
        paymentMethod.paymentMethodStatus === VERIFICATION_STATUS.PLAID_REVOKED,
    ) || []
  );
};
